import React from 'react';
import { Edit } from 'lucide-react';

const StudentCard = ({ 
  student, 
  isSelected, 
  onClick, 
  onDetailClick 
}) => {
  // 담당 선생님 정보 가져오기 (teacher_name 또는 in_charge_teacher 사용)
  const teacherName = student.teacher_name || student.in_charge_teacher;
  
  return (
    <div
      onClick={onClick}
      className={`relative cursor-pointer rounded-3xl border bg-white p-[14.4px] shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] hover:border-primary/20
        ${isSelected ? 'border-transparent ring-2 ring-primary' : 'border-gray-200'}`}
      style={{ width: '100%', marginBottom: '7.2px' }}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          // console.log('StudentCard Edit 버튼 클릭됨:', student);
          onDetailClick(student);
        }}
        className="absolute right-1.5 top-1.5 z-10 flex touch-manipulation items-center justify-center rounded-full p-1.5 transition-colors hover:bg-gray-100"
        style={{ minWidth: '32px', minHeight: '32px' }}
        title="상세 정보"
        type="button"
      >
        <Edit size={14} className="text-gray-500 transition-colors hover:text-primary" />
      </button>
      
      <div className="grid grid-cols-[6fr_4fr_44px] items-center">
        {/* 좌측 영역 - 기존 학생 정보 */}
        <div className="flex min-w-0 items-center gap-2 pr-2">
          <div 
            className="flex shrink-0 items-center justify-center rounded-full text-white font-bold text-sm bg-gradient-to-r from-primary to-primary/70"
            style={{ width: '32px', height: '32px' }}
            title={`학생 ID: ${student.student_id}`}
          >
            {student.student_id}
          </div>
          
          <div className="min-w-0 flex-1 overflow-hidden">
            <h4 className="truncate text-sm font-medium">{student.student_name}</h4>
            <p className="truncate text-xs text-gray-600">{student.school_name} · {student.school_grade}학년</p>
            <p className="truncate text-xs text-gray-500">{student.student_email}</p>
          </div>
        </div>
        
        {/* 중앙 영역 - 담당 선생님 & 강의반 정보 */}
        <div className="flex items-center">
          <div className="flex flex-1 flex-col justify-center text-right">
            {(teacherName || student.lecture) ? (
              <>
                {teacherName && (
                  <div className="flex items-center justify-end text-xs">
                    <span className="shrink-0 text-gray-500">담당:</span>
                    <span className="ml-1 truncate font-medium text-gray-700" style={{ maxWidth: '80px' }}>
                      {teacherName}
                    </span>
                  </div>
                )}
                {student.lecture && (
                  <div className="mt-0.5 flex items-center justify-end text-xs">
                    <span className="shrink-0 text-gray-500">강의:</span>
                    <span className="ml-1 truncate font-medium text-gray-700" style={{ maxWidth: '80px' }}>
                      {student.lecture}
                    </span>
                  </div>
                )}
              </>
            ) : (
              <div className="text-xs text-gray-400">-</div>
            )}
          </div>
        </div>
        
        {/* 우측 영역 - Edit 버튼을 위한 공간 */}
        <div></div>
      </div>
    </div>
  );
};

export default StudentCard; 